import {gql} from "@apollo/client";

export const GET_ALL_PACKGE_PRICE = gql`
  query {
    getAllPackagePrice {
      data {
        id
        name
        service
        serviceType
        order
      }
      errors {
        message
      }
    }
  }
`;

export const GET_PACKAGE_PRICE_BY_ID = gql`
  query ($id: Float!) {
    getPackagePriceBasedOnId(id: $id) {
      data {
        id
        name
        service
        serviceType
        note
        packagePrice {
          basicPrice
          goldPrice
          premiumPrice
          location
          tab
          category
          range {
            min
            max
          }
        }
        serviceItem {
          id
          name
          description
          isPublic
        }
      }
      errors {
        message
      }
    }
  }
`;

export const GET_PACKAGE_PRICE_BY_SERVICE_TYPE = gql`
  query ($type: PopularServiceOptionsEnumType!) {
    getPackagePriceBasedOnType(type: $type) {
      data {
        id
        name
        service
        serviceType
        packagePrice {
          basicPrice
          goldPrice
          premiumPrice
          location
          tab
          category
          range {
            min
            max
          }
        }
        serviceItem {
          id
          name
          description
          isPublic
        }
      }
      errors {
        message
      }
    }
  }
`;
